import { render } from "./Ml.vue?vue&type=template&id=0e5524af&scoped=true&bindings={\"shared\":\"options\",\"readEmail\":\"options\",\"archiveEmail\":\"options\",\"updateEmail\":\"options\",\"openEmail\":\"options\",\"handleModalClosed\":\"options\",\"format\":\"setup\",\"emails\":\"setup\",\"openedEmail\":\"setup\"}"
import script from "./Ml.vue?vue&type=script&lang=js"
export * from "./Ml.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0e5524af"

export default script